<template>
	<div>
		<modalconfirm ref="modalSyncProduct" @action="addProductSupplier"/>
		<div class="text-h5">Tambah Produk Supplier</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-row>
					<v-col cols="12">
						<v-col cols="4" class="pa-0">
							<v-autocomplete item-text="supplier_name" item-value="supplier_id" outlined dense hide-details v-model="supplier_selected" :items="supplierResults" label="Supplier" no-data-text="Tidak ada data yang sesuai"></v-autocomplete>
						</v-col>
					</v-col>
					<v-col cols="6" >
						<div class="text-subtitle-1 font-weight-bold">Produk Supplier</div>
						<v-data-table v-model="product_supplier" show-select single-select item-key="supplier_product_id" disable-pagination :headers="headerSupplier" :items="productSupplier" hide-default-footer class="mt-2" no-data-text="Belum ada produk tersedia">
							<template v-slot:item.supplier_product_price="{ item }">
								<div>{{ item.supplier_product_price | toNumber }}</div>
							</template>
						</v-data-table>
					</v-col>
					<v-col cols="6" >
						<div class="text-subtitle-1 font-weight-bold">Produk Warehouse</div>
						<v-data-table v-model="product_warehouse" show-select single-select item-key="product_id" disable-pagination :headers="headerWarehouse" :items="productWarehouse" hide-default-footer class="mt-2" no-data-text="Belum ada produk tersedia">
							<template v-slot:item.product_price="{ item }">
								<div>{{ item.product_price | toNumber }}</div>
							</template>
						</v-data-table>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="px-4 pb-4">
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" :disabled="product_warehouse.length == 0 || product_supplier.length == 0" depressed class="text-capitalize" @click="sync">Tambahkan Produk</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			product_supplier: [],
			product_warehouse: [],
			supplier_selected: '',
			paramGet: '',
			headerSupplier: [
			{ text: 'Nama Produk', align: 'start', value: 'supplier_product_name', sortable: true},
			{ text: 'Kode Produk', value: 'supplier_product_code', sortable: false},
			{ text: 'Harga Produk', value: 'supplier_product_price', align: 'end'},
			],
			headerWarehouse: [
			{ text: 'Nama Produk', align: 'start', value: 'product_name', sortable: true},
			{ text: 'Kode Produk', value: 'product_code', sortable: false},
			{ text: 'Harga Produk', value: 'product_price', align: 'end'},
			],
		}
	},
	props: {
	},
	computed: {
		...mapState('supplierList', ['supplierResults']),
		...mapState('productSupplier', ['productWarehouse', 'productSupplier']),
	},
	methods: {
		...mapActions('supplierList', ['getSupplier']),
		...mapActions('productSupplier', ['getProductWarehouseBySupplier', 'getProductSupplierBySupplier', 'syncProduct']),
		...mapMutations('productSupplier', ['clearDataProductSupplier']),
		...mapMutations(['setOverlay']),

		sync() {
			let msg = `Yakin ingin mencocokan ${this.product_warehouse[0].product_name} dengan ${this.product_supplier[0].supplier_product_name}?`
			this.$refs.modalSyncProduct.showConfirm()
			this.$refs.modalSyncProduct.setMessage(msg)
		},
		async addProductSupplier() {
			await this.setOverlay(true)
			await this.$refs.modalSyncProduct.hideConfirm()
			let params = await {
				product_id: this.product_warehouse[0].product_id,
				supplier_id: this.supplier_selected,
				supplier_product_id: this.product_supplier[0].supplier_product_id
			}
			await this.syncProduct(params).then( () => {
				this.resetForm()
			})
			await this.setOverlay(false)
		},
		resetForm() {
			this.getProductWarehouseBySupplier(this.paramGet)
			this.getProductSupplierBySupplier(this.paramGet)
			this.product_supplier = []
			this.product_warehouse = []
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Tambah Supplier Produk`)
		this.getSupplier(this.queryString({limit:100}))
	},
	beforeDestroy() {
		this.clearDataProductSupplier()
	},
	watch: {
		supplier_selected(val) {
			this.paramGet = {
				supplier_id : val,
				limit: 1000
			}
			this.getProductWarehouseBySupplier(this.paramGet)
			this.getProductSupplierBySupplier(this.paramGet)
		}
	}
}
</script>